import React, { memo } from "react"
import { twMerge } from "tailwind-merge"
import { ReactComponent as CheckSmallIcon } from "@assets/icons/checked_small.svg"

type BarStepsProgressProps = {
  activeStep: number
}

const BarStepsProgress: React.FC<BarStepsProgressProps> = ({ activeStep }) => {
  const steps = ["Complete Fact Find", "Select Pension", "Complete Form", "Get Pension"]

  return (
    <div className="flex items-center gap-x-2 md:gap-x-6">
      <div className="block">
        <span className="text-pn-body-emphasis md:text-pn-headline-emphasis">Get Penny Ready</span>
      </div>
      <div className="flex-1 p-2 flex items-center gap-x-2 justify-end">
        {steps.map((item, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center gap-x-[7px]">
              <div
                className={twMerge(
                  activeStep === index + 1
                    ? "bg-[#F4E34E]"
                    : activeStep > index
                      ? "bg-pn_green-500"
                      : "bg-pn_gray-200",
                  "w-6 h-6 rounded-full flex items-center justify-center",
                )}
              >
                <span className="text-pn-button-2 text-pn_gray-950">
                  {activeStep > index && activeStep !== index + 1 ? <CheckSmallIcon /> : index + 1}
                </span>
              </div>
              <div className="flex-1 hidden lg:block">
                <span className="text-pn-callout-emphasis">{item}</span>
              </div>
            </div>
            {index !== 3 && <div className="h-[2px] flex-1 max-w-[90px] w-full bg-pn_gray-200"></div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
export default memo(BarStepsProgress)
